import React, { createContext, useReducer, useEffect, useState } from "react";
import initstate from "./initialState/initstate";
import Initreducer from "./reducer/initreducer";
import init from './action/init/initaction';
import Reportreducer from "./reducer/report";
import report from "./initialState/report";
export const GlobalContext = createContext({});

const GlobalProvider = ({ children }) => {
    const [initState, initDispatch] = useReducer(Initreducer, initstate);
    const [reportState, reportDispatch] = useReducer(Reportreducer, report);
    const [recaller, setrecaller] = useState(0);


    useEffect(() => {
        init()(initDispatch);
    }, [recaller]);
    return <GlobalContext.Provider value={{
        initState, initDispatch,
        reportState, reportDispatch,
        recaller, setrecaller,
    }}>{children}</GlobalContext.Provider>
}

export default GlobalProvider;